import TextIcon from '@atlaskit/icon/core/text';
import * as React from 'react';

export function SvgText() {
  return <TextIcon label="" testId="ads-refreshed-icon" />;
}
